import { render, staticRenderFns } from "./RecruitmentModule.vue?vue&type=template&id=e5e138e2&scoped=true&"
import script from "./RecruitmentModule.vue?vue&type=script&lang=js&"
export * from "./RecruitmentModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e138e2",
  null
  
)

export default component.exports